define('gameday-index-gdaudio/subcomponents/FeedFetcher',['require','exports','module','jquery','gameday-index-url-hasher/UrlHasher','gameday-index-enums/enums/baseball/GIDDecoder','./AudioFeedModel','gameday-index-enums/enums/events/LoadEvents','message-service/message-service','extant/extant','app-console/app-console'],function(require, exports, module) {
	var $ = require("jquery"),
		UrlHash = require("gameday-index-url-hasher/UrlHasher"),
		GID = require("gameday-index-enums/enums/baseball/GIDDecoder"),
		FeedVO = require("./AudioFeedModel"),
		LoadEvents = require("gameday-index-enums/enums/events/LoadEvents"),
		MessageService = require("message-service/message-service"),
		exists = require("extant/extant"),
		logg = require("app-console/app-console");

	var PB_SCENARIO = "AUDIO_FMS_32K",
		game;


	function FeedFetcher() {
		game = GDC.getGameData("linescore");
	}

	FeedFetcher.prototype = {
		feeds: null,
		/**
		 * Makes XHR request for MediaGrid data based on date
		 */
		loadGrid: function(gid) {
			var url = [
				"/gdcross/components/game/mlb",
				"/year_", gid.year,
				"/month_", gid.month,
				"/day_", gid.day,
				"/grid.json"
			].join('');

			$.ajax({
				url: url,
				dataType: "text",
				cache: true,
				dataFilter: $.proxy(this.filterGrid, this),
				success: $.proxy(this.handleGridLoad, this),
				error: $.proxy(this.handleGridLoad, this)
			});
		},

		/**
		 * Searches for the specified game within the MediaGrid datafile
		 * and returns a Game Media Catalog object representing the game's media
		 * catalog
		 */
		filterGrid: function($data) {
			var data = $.parseJSON($data);
			var gameMediaCatalog = null,
				games = [].concat(data.data.games.game),
				cid = (exists(game, "linescore.game_media.calendar_event_id")) ? game.linescore.game_media.calendar_event_id : "",
				thisGame;

			for (var i = 0, l = games.length; i < l; i++) {
				thisGame = games[i];
				if (cid !== "" && thisGame.calendar_event_id !== "" && cid === thisGame.calendar_event_id) {
					gameMediaCatalog = createMediaCatalog(thisGame);
					break;
				}
			}

			return gameMediaCatalog;
		},

		handleGridLoad: function($data) {
			if (exists($data) && exists($data.mediaItems)) {
				logg.log("you win!");
				this.feeds = $data;
				MessageService.publish(LoadEvents.audioFeedsLoaded, this.feeds);
			} else {
				logg.log("you fail!");
				MessageService.publish(LoadEvents.noAudioFeedsAvailable);
			}
		}
	};


	/**
	 * Returns a JavaScript object representation of a game's media streams,
	 * including Combined Media State
	 *
	 * This method is configured to only return audio streams, but could easily
	 * be refactored to accomodate video streams
	 */
	function createMediaCatalog($game) {
		var media = [].concat($game.game_media.homebase.media),
			combinedMediaState = null,
			audioItems = {},
			feed;

		for (var i = 0, l = media.length; i < l; i++) {
			feed = media[i];

			if (feed.playback_scenario === PB_SCENARIO) {
				audioItems[feed.type] = new FeedVO(feed, game);
			}

			if (!combinedMediaState) {
				combinedMediaState = feed.combined_media_state;
			}
		}

		return {
			combinedMediaState: combinedMediaState,
			mediaItems: audioItems
		};
	}

	return FeedFetcher;
});
